import axios from 'axios'
import { ENTRYPOINT } from '../../../config/entrypoint'

export default {
  state: {
    statInfoList: [],
    usersConnected: [],
    usersConnectedCount: 0,
    statCreatedProjectList: [],
    statTempsConnexionList: [],
    statTempsModuleList: []

  },
  actions: {
    async getStatInfoList ({ commit }, payload) {
      const statInfoList = await axios({ url: ENTRYPOINT + '/api/statistique-utilisation/frequence-connexion', data: payload, method: 'POST' })
      commit('STAT_INFO_LIST', statInfoList.data.data)
    },
    async getConnectedInvite ({ commit }) {
      const connectedUsers = await axios({ url: ENTRYPOINT + '/api/statistique-utilisation/utilisateur-connecte', method: 'GET' })
      commit('CONNECTED_USER', connectedUsers.data.data)
    },
    async getStatCreatedProject ({ commit }, payload) {
      const statCreatedProject = await axios({ url: ENTRYPOINT + '/api/statistique-utilisation/projet-cree', data: payload, method: 'POST' })
      commit('STAT_CREATED_PROJECT_LIST', statCreatedProject.data.data)
    },
    async getStatTempsConnexion ({ commit }, payload) {
      const statTempsConnexion = await axios({ url: ENTRYPOINT + '/api/statistique-utilisation/temps-par-connexion', data: payload, method: 'POST' })
      commit('STAT_TEMPS_CONNEXION_LIST', statTempsConnexion.data.data)
    },
    async getStatTempsConnexionModule ({ commit }, payload) {
      const statTempsModule = await axios({ url: ENTRYPOINT + '/api/statistique-utilisation/temps-par-module', data: payload, method: 'POST' })
      commit('STAT_TEMPS_MODULE_LIST', statTempsModule.data.data)
    }
  },
  getters: {
    statInfoList: (state) => state.statInfoList,
    usersConnected: (state) => state.usersConnected,
    usersConnectedCount: (state) => state.usersConnectedCount,
    statCreatedProjectList: (state) => state.statCreatedProjectList,
    statTempsConnexionList: (state) => state.statTempsConnexionList,
    statTempsModuleList: (state) => state.statTempsModuleList
  },
  mutations: {
    STAT_INFO_LIST (state, value) {
      state.statInfoList = value
    },
    CONNECTED_USER (state, value) {
      state.usersConnectedCount = value.length
      state.usersConnected = value.map(user => {
        return `${user.nom} ${user.prenom}`
      })
    },
    STAT_CREATED_PROJECT_LIST (state, value) {
      state.statCreatedProjectList = value
    },
    STAT_TEMPS_CONNEXION_LIST (state, value) {
      state.statTempsConnexionList = value
    },
    STAT_TEMPS_MODULE_LIST (state, value) {
      state.statTempsModuleList = value
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/statistiques/index.js